import { useMemo } from 'react';
import useUsersStore from './useUsersStore';
import { shallow } from 'zustand/shallow';

const useUsersFacade = () => {
  const {
    userInfo,
    loading,
    error,
    fetchUsers,
    updateFirstTimeFlag,
    resetUserInfo,
  } = useUsersStore(
    (state) => ({
      userInfo: state.userInfo,
      loading: state.loading,
      error: state.error,
      fetchUsers: state.fetchUsers,
      updateFirstTimeFlag: state.updateFirstTimeFlag,
      resetUserInfo: state.resetUserInfo,
    }),
    shallow
  );

  const memoizedValues = useMemo(
    () => ({
      userInfo,
      loading,
      error,
      fetchUsers,
      updateFirstTimeFlag,
      resetUserInfo,
    }),
    [userInfo, loading, error, fetchUsers, updateFirstTimeFlag, resetUserInfo]
  );

  return memoizedValues;
};

export default useUsersFacade;
